/* NRU recently viewed — v2.0.
   Records the products a shopper opens and shows them in the "Recent" tab of
   the search drawer. Only the handle and the product URL are stored
   (device-only, localStorage, most recent first, de-duplicated, capped at 20)
   — titles, prices, images, availability and variants come from Shopify's
   product JSON through the shared panel store, so rows are never stale and a
   product that is also saved is only ever fetched once.
   The product being viewed right now is recorded immediately but hidden from
   the panel on its own page, so the list never just echoes where you are. */
(function () {
  var KEY = 'nru_recently_viewed_v1';
  var MAX = 20;

  /* nru-wishlist.js owns the shared store and the shared row builder and is
     loaded just before this file. The small stand-in keeps the rows working if
     it ever is not there. */
  var store = window.nruProductStore || {
    peek: function () { return null; },
    load: fetchProduct,
    warm: function () {}
  };

  function fetchProduct(path) {
    return fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('unavailable');
        return r.json();
      })
      .then(function (p) {
        return {
          title: p.title || '',
          price: typeof p.price === 'number' ? p.price : null,
          priceMax: typeof p.price_max === 'number' ? p.price_max : null,
          varies: !!p.price_varies,
          compare: p.compare_at_price || 0,
          image: p.featured_image || (p.images && p.images[0]) || '',
          available: p.available !== false,
          variants: (p.variants || []).map(function (v) {
            return { id: v.id, title: v.title, available: v.available !== false };
          })
        };
      })
      .catch(function () { return null; });
  }

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function handleFromUrl(url) { var m = String(url || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; }
  /* Always store the canonical /products/<handle> path: the same product is
     reachable as /collections/x/products/y, and that must not become a
     second entry (or miss a de-duplication). */
  function urlFor(handle) { return '/products/' + handle; }
  function currentHandle() {
    if (!/\/products\//.test(location.pathname)) return '';
    return handleFromUrl(location.pathname.split('?')[0]);
  }

  /* The list the panel shows: everything except the product on screen. */
  function visible() {
    var here = currentHandle();
    return read().filter(function (i) { return i && i.handle && i.handle !== here; });
  }

  function track() {
    var handle = currentHandle();
    if (!handle) return;
    var list = read();
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].handle === handle) { list.splice(i, 1); break; }
    }
    list.unshift({ url: urlFor(handle), handle: handle });
    if (list.length > MAX) list = list.slice(0, MAX);
    write(list);
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    }).then(function (r) {
      return r.json().then(function (j) {
        /* The drawer watches every cart request itself and updates its badge,
           the header bubble and its own rows from the response. */
        if (r.ok && j && j.id) {
          try { document.dispatchEvent(new CustomEvent('cart:item-added')); } catch (e) {}
        }
        return { ok: r.ok, body: j };
      });
    });
  }

  var CLOCK_ICON =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><path d="M12 7.2v5.05l3.4 2.05" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var renderToken = 0;
  function renderRecent() {
    var body = document.querySelector('[data-nru-recent-body]');
    var kit = window.nruPanelRow;
    if (!body || !kit) return;
    var toolbar = document.querySelector('[data-nru-recent-toolbar]');
    var summary = document.querySelector('[data-nru-recent-summary]');
    var list = visible();

    if (toolbar) toolbar.hidden = !list.length;
    if (summary) summary.textContent = list.length + (list.length === 1 ? ' product' : ' products');

    if (!list.length) {
      body.innerHTML = kit.empty({
        icon: CLOCK_ICON,
        title: 'Nothing viewed yet',
        text: 'Products you open will show up here so you can find your way back.',
        action: 'Browse products'
      });
      return;
    }

    var token = ++renderToken;
    /* Rows are on screen at their finished height straight away; the product
       JSON drops into them without moving anything. */
    body.innerHTML = list
      .map(function (entry) {
        return kit.build({ url: entry.url, data: store.peek(entry.url), prefix: 'recent', remove: false });
      })
      .join('');

    var rows = body.querySelectorAll('.nru-panel-row');
    list.forEach(function (entry, i) {
      var row = rows[i];
      if (!row || !row.classList.contains('is-loading')) return;
      store.load(entry.url).then(function (data) {
        if (token !== renderToken || !row.parentNode) return;
        kit.fill(row, { url: entry.url, data: data, prefix: 'recent', remove: false });
      });
    });
  }

  function handleAdd(row, btn) {
    var sel = row.querySelector('[data-nru-recent-variant]');
    var single = row.querySelector('[data-nru-recent-variant-single]');
    var id = sel ? sel.value : (single ? single.value : null);
    if (!id) return;
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'Adding…';
    addToCart(id, 1).then(function (res) {
      if (res.ok && res.body && res.body.id) {
        btn.textContent = 'Added ✓';
        btn.classList.add('is-added');
        setTimeout(function () { btn.disabled = false; btn.textContent = original; btn.classList.remove('is-added'); }, 1600);
      } else {
        btn.textContent = 'Unavailable';
        setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 1600);
      }
    }).catch(function () {
      btn.textContent = 'Try again';
      setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 1600);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-nru-recent-clear]')) { write([]); renderRecent(); return; }
    var addBtn = t.closest('[data-nru-recent-add]');
    if (addBtn) {
      var row = addBtn.closest('.nru-panel-row');
      if (row) handleAdd(row, addBtn);
    }
  });

  document.addEventListener('nru:panel', function (e) {
    if (e.detail && e.detail.tab === 'recent') renderRecent();
  });

  function boot() {
    track();
    renderRecent();
    store.warm(visible().slice(0, 10).map(function (entry) { return entry.url; }));
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
